module.exports = __webpack_public_path__ + "static/img/Toby-Sexton.d97afcc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Toby-Sexton.jpg
// module id = bfMY
// module chunks = 0